import { Action, actionCreator } from '@trello/redux';
import { Dispatch, StandardThunkAction } from 'app/gamma/src/types';
import API from 'app/gamma/src/api';
import { Noun, trackUe, Verb } from '@trello/analytics';

export const DELETE_BOARD = Symbol('models/DELETE_BOARD');

export type DeleteBoardAction = Action<typeof DELETE_BOARD, string>;

export const deleteBoardAction = actionCreator<DeleteBoardAction>(DELETE_BOARD);

export const deleteBoard = ({
  idBoard,
}: {
  idBoard: string;
}): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    try {
      await API.client.rest.del(`boards/${idBoard}`);
      dispatch(deleteBoardAction(idBoard));

      trackUe({
        category: Noun.BOARD,
        verb: Verb.DELETES,
        directObj: Noun.BOARD,
        method: 'any method available to delete a new board',
      });
    } catch (err) {
      console.error(err);
    }
  };
};
